import { useState, useEffect, createContext } from 'react';
import { useSelector } from 'react-redux';
import { ApprovalProvider } from 'ui-product-approvals/components/ApprovalProvider';
import { ApprovalActions } from 'ui-product-approvals-common';

// @ts-ignore dependency missing types
import { fetchObjectIdForContentId } from '../../api/CrmSearchApi';
import TestVariationAlertContent from './TestVariationAlertContent';
import { getCrmObjectId } from 'ContentEditorUI/redux/selectors/contentReadOnlyDataSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
export const EditorApprovalContext = /*#__PURE__*/createContext({
  hasReadAccessToProductApprovals: false,
  hasWriteAccessToProductApprovals: false
});
export const EditorApprovalProvider = ({
  children,
  assetName,
  contentId,
  hasReadAccessToProductApprovals,
  hasWriteAccessToProductApprovals,
  approvalType,
  restartOnConclude
}) => {
  const crmObjectId = useSelector(getCrmObjectId);
  const [objectId, setObjectId] = useState(crmObjectId);
  useEffect(() => {
    if (hasReadAccessToProductApprovals && !objectId && contentId) {
      fetchObjectIdForContentId({
        contentId,
        approvalType,
        onComplete: value => setObjectId(value)
      });
    }
  }, [approvalType, contentId, hasReadAccessToProductApprovals, objectId]);
  if (!hasReadAccessToProductApprovals || !approvalType) {
    return children;
  }
  return /*#__PURE__*/_jsx("div", {
    "data-test-id": "editor-approval-provider",
    children: /*#__PURE__*/_jsx(EditorApprovalContext.Provider, {
      value: {
        hasReadAccessToProductApprovals,
        hasWriteAccessToProductApprovals
      },
      children: /*#__PURE__*/_jsx(ApprovalProvider, {
        approvableObjectId: objectId,
        assetName: assetName,
        approvalType: approvalType,
        approvalAction: ApprovalActions.PUBLISH,
        modalAlertContent: /*#__PURE__*/_jsx(TestVariationAlertContent, {}),
        restartOnConclude: restartOnConclude,
        children: children
      })
    })
  });
};
export default EditorApprovalProvider;